export default __webpack_public_path__ + "static/media/1859.8e76a1bf.png";